import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugEfavirez} from "./TextDrugEfavirez"


export default function Efavirenz() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
  
    <ButtonsText onClick={handleOpen} name='Efavirenz' size='large' color='common.white' />
    
    <CustomDialog open={open} onClose={handleClose}

        title="Efavirenz - PGx Recommendation"
        content={ <TextDrugEfavirez />}

        />

</>
)}